import { useState } from "react";
import ReactModal from "react-modal";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import useTriggeredAPICall from "../../hooks/fetch-hooks/useTriggeredAPICall";
import { errorToast, successfulToast } from "../../util/toastNotifications";

ReactModal.setAppElement("#root");

const ConfirmDelete = (props) => {
  const { objectType, id, users, isTaskDrawerOpen, closeTaskDrawer } = props;
  const [modalOpen, setModalOpen] = useState(false);

  const history = useHistory();
  const { fetchData } = useTriggeredAPICall();

  function handleDelete() {
    setModalOpen(false);
    fetchData(`/${objectType}/delete/${id}`, "DELETE")
      .then(() => {
        const label = objectType.replace(/^./, (char) => char.toUpperCase());
        successfulToast(`${label} deleted successfully`);
        if (isTaskDrawerOpen) {
          closeTaskDrawer();
        } else {
          history.push(`/${objectType}s`);
        }
      })
      .catch((err) => {
        console.error(`Deleting ${objectType}`, err);
        const label = objectType.replace(/^./, (char) => char.toUpperCase());
        errorToast(`Failed to delete ${label.toLowerCase()}`);
      });
  }

  return (
    <>
      <button className="delete-button" onClick={() => setModalOpen(true)}>
        Delete {objectType.replace(/^./, (char) => char.toUpperCase())}
      </button>

      <ReactModal
        isOpen={modalOpen}
        className="delete-modal"
        overlayClassName="delete-modal-overlay"
        onRequestClose={() => setModalOpen(false)}
      >
        <div className="icon">
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </div>

        {objectType === "organization" ? (
          <div className="are-you-sure">
            All associated records must be removed before deletion. Are you sure
            you want to delete this organization?
          </div>
        ) : (
          <div className="are-you-sure">
            Are you sure you want to delete this {objectType}?
          </div>
        )}

        <button className="cancel-button" onClick={() => setModalOpen(false)}>
          Cancel
        </button>

        <button className="delete-button" onClick={() => handleDelete()}>
          Yes
        </button>
      </ReactModal>
    </>
  );
};

export default ConfirmDelete;
